<popup-c class="bs-enabled onboarding-wizard" size="large" width="1400px" height="850px">
	<div class="flxClmn f-1-0" style="overflow: auto; min-height: 0;">

		<!--Gradient header-->
		<div class="wizard-header flxRow-between" style="align-items: center;">
			<span style="color: white; font-size: 16px; letter-spacing: 0.3px;">Onboarding Wizard - {{gs.controlAdmin?.company_name || gs.controlAdmin?.display_email || 'Your Organization'}}</span>
			<i class="zmdi zmdi-close cursor-pointer" style="color: white; font-size: 22px; padding: 4px 8px;" (click)="closeCb.emit()"></i>
		</div>

		<!--CC: loading state-->
		<div class="flxClmn-center align-items-center f-1-0" *ngIf="isWizardLoading">
			<loader></loader>
		</div>

		<!--Body: left sidebar | center | right explanation-->
		<div class="flxRow f-1-0" style="overflow: auto; min-height: 0;" *ngIf="!wizardComplete && !isWizardLoading">

			<!--Left sidebar — main steps list-->
			<div class="flxClmn" style="width: 260px; flex-shrink: 0; overflow: auto; background: #f9f9f9;">
				<ng-container *ngFor="let stepEntry of steps | keyvalue: gs.returnZero">
					<div class="wizard-step-item flxRow align-items-center"
						 *ngIf="stepEntry.value.visible !== false"
						 [ngClass]="{'active': activeStepKey === stepEntry.key}"
					 style="pointer-events: none;">
						<div class="step-circle d-flex align-items-center justify-content-center">
							{{stepEntry.value.num}}
						</div>
						<span class="step-label" [ngClass]="{'text-primary fw-bold': activeStepKey === stepEntry.key}">
							{{stepEntry.value.label}}
						</span>
					</div>
				</ng-container>
			</div>

			<!--Center — sub-step tabs, title, content, footer-->
			<div class="flxClmn f-1-0" style="overflow: auto; min-width: 0;">

				<!--Sub-step progress tabs-->
				<div class="steps-container" style="padding: 8px;">
					<ng-container *ngFor="let subStepEntry of steps[activeStepKey].subSteps | keyvalue: gs.returnZero">
						<div class="step-tab"
							 *ngIf="subStepEntry.value.visible !== false"
							 [ngClass]="{'active': activeSubStepKey === subStepEntry.key}">
							{{subStepEntry.value.label}}
						</div>
					</ng-container>
				</div>

				<!--Sub-step bold title + explanation-->
				<div class="flex-column gap-1 position-relative" style="padding: 14px 20px; flex-shrink: 0;">
					<div class="flex-row align-items-center">
						<b style="flex: 1; text-align: center;" *ngIf="steps[activeStepKey].subSteps[activeSubStepKey].title">{{steps[activeStepKey].subSteps[activeSubStepKey].title}}</b>
						<!--CC: static substep guide link-->
						<a class="flex-row align-items-center gap-1" style="font-size: 12px; position: absolute; right: 10px; top: 0;"
						   target="_blank"
						   [href]="steps[activeStepKey].subSteps[activeSubStepKey].guide"
						   *ngIf="steps[activeStepKey].subSteps[activeSubStepKey].guide">
							<btn-c class="shrunk" variant="outlined" endIcon="far fa-sm fa-external-link">
								<span class="p-1 text-primary">Docs</span>
							</btn-c>
						</a>
						<!--CC: dynamic deployment guide links-->
						<div class="flex-row align-items-center gap-3" style="position: absolute; right: 10px; top: 0;"
							 *ngIf="!steps[activeStepKey].subSteps[activeSubStepKey].guide && ((activeStepKey === 'deployOutboundShield' && activeOutboundGuides.length) || (activeStepKey === 'deployInboundShield' && activeInboundGuides.length))">
							<ng-container *ngFor="let guide of (activeStepKey === 'deployOutboundShield' ? activeOutboundGuides : activeInboundGuides)">
								<a class="flex-row align-items-center gap-1" style="font-size: 12px;" target="_blank" [href]="guide.url" rel="noopener noreferrer">
									<btn-c class="shrunk" variant="outlined" endIcon="far fa-sm fa-external-link">
										<span class="p-1 text-primary">Docs</span>
									</btn-c>
								</a>
							</ng-container>
						</div>
					</div>
					<span *ngIf="steps[activeStepKey].subSteps[activeSubStepKey].explanation" class="text-center" style="font-size: 13px; line-height: 1.5;">
						{{steps[activeStepKey].subSteps[activeSubStepKey].explanation}}
					</span>
				</div>

				<!--Step content-->
				<div class="flxClmn f-1-0" style="overflow: auto; padding: 0 20px;">
					<ng-container [ngTemplateOutlet]="stepContent"></ng-container>
				</div>

				<!--Footer — validation error + Back / Next + Skip-->
				<div class="flxRow-between" style="align-items: center; padding: 15px 20px; flex-shrink: 0;">
					<div class="flxRow hSpace2" style="align-items: center;">
						<span class="text-danger animated fadeIn" style="font-size: 13px;" *ngIf="wizardError">{{wizardError}}</span>
						<btn-c class="popup-action-btn" variant="outlined" startIcon="far fa-arrow-left" *ngIf="!isFirstPosition" (action)="back();">
							Back
						</btn-c>
					</div>
					<div class="flxRow hSpace2" style="align-items: center;">
						<btn-c variant="text" *ngIf="steps[activeStepKey].skippable && hasNextPosition" (action)="proceedToNextStep();">
							Skip
						</btn-c>
						<btn-c class="popup-action-btn" endIcon="far fa-arrow-right"
							   *ngIf="hasNextPosition"
							   (action)="next();">
							Next
						</btn-c>
						<btn-c class="popup-action-btn"
							   *ngIf="!hasNextPosition"
							   (action)="next();">
							Finish
						</btn-c>
					</div>
				</div>

			</div>
		</div>

		<!--Wizard complete screen-->
		<div class="wizard-complete flxClmn-center f-1-0 align-items-center gap-4" style="padding: 60px 40px;" *ngIf="wizardComplete && !isWizardLoading">
			<div class="confetti-container">
				<div class="confetti-piece" *ngFor="let piece of [].constructor(80)"></div>
			</div>
			<i class="complete-icon far fa-check-circle text-success" style="font-size: 64px;"></i>
			<b class="complete-title" style="font-size: 22px;">Onboarding Complete</b>
			<span class="complete-subtitle text-muted text-center" style="font-size: 14px; line-height: 1.6;">
				Your {{gs.corpname}} setup is complete. You can now close this wizard and start using the platform.
			</span>
			<btn-c class="complete-btn popup-action-btn" (action)="closeCb.emit();">
				Close
			</btn-c>
		</div>
	</div>
</popup-c>

<!--CC: step content switch — each ngIf maps a stepKey+subStepKey to its content component-->
<ng-template #stepContent>

	<!--CC: unified environment & scope selection-->
	<div class="flex-column" style="overflow: auto; gap: 20px;" *ngIf="activeStepKey === 'environmentScope' && activeSubStepKey === 'selectEnvironmentAndScope'">

		<!--CC: email service section-->
		<span style="font-size: 13px;">Which email service does your organization use?</span>

		<!--CC: all email services in one row-->
		<div class="flex-row gap-3">
			<ng-container *ngFor="let serviceEntry of steps.environmentScope.emailServices | keyvalue: gs.returnZero">
				<div class="email-service-card flex-column align-items-center gap-2 border border-2 rounded p-3 hvr-darken-light cursor-pointer position-relative text-center"
					 [ngClass]="{'border-primary shadow': steps.environmentScope.selectedEmailService === serviceEntry.value.key,
					 			 'border-secondary-subtle': steps.environmentScope.selectedEmailService !== serviceEntry.value.key}"
					 (click)="selectEmailService(serviceEntry.value.key)">
					<i class="far" style="position: absolute; top: 6px; left: 6px; font-size: 0.85rem;"
					   [ngClass]="{'fa-dot-circle text-primary': steps.environmentScope.selectedEmailService === serviceEntry.value.key,
					   			   'fa-circle text-muted': steps.environmentScope.selectedEmailService !== serviceEntry.value.key}"></i>
					<img *ngIf="serviceEntry.value.logo" [src]="serviceEntry.value.logo" style="width: 40px; height: 40px; object-fit: contain;" />
					<i class="far fa-envelope" style="font-size: 32px; color: var(--bs-secondary);" *ngIf="!serviceEntry.value.logo"></i>
					<span class="fw-bold" style="font-size: 12px;">{{serviceEntry.value.label}}</span>
					<span class="text-muted" style="font-size: 11px;">{{serviceEntry.value.subtitle}}</span>
				</div>
			</ng-container>
		</div>

		<!--CC: divider between sections-->
		<div style="width: 100%; height: 1px; background: var(--bs-border-color);"></div>

		<!--CC: protection scope section-->
		<span style="font-size: 13px;">What would you like to protect?</span>

		<!--CC: no-permission alert shown immediately-->
		<div class="flex-row align-items-center gap-2 p-3 rounded border border-danger" style="background: rgba(220, 53, 69, 0.06);"
			 *ngIf="noScopePermission">
			<i class="far fa-exclamation-circle text-danger" style="font-size: 1.2rem;"></i>
			<span class="text-danger" style="font-size: 13px;">You do not have permission to configure inbound or outbound protection. Please contact your administrator.</span>
		</div>
		<div class="flex-row align-items-center gap-2 p-3 rounded border border-danger" style="background: rgba(220, 53, 69, 0.06);"
			 *ngIf="!noScopePermission && wizardInfo?.permissions && !wizardInfo.permissions.inbound">
			<i class="far fa-exclamation-circle text-danger" style="font-size: 1.2rem;"></i>
			<span class="text-danger" style="font-size: 13px;">You do not have permission to configure inbound protection. Please contact your administrator.</span>
		</div>
		<div class="flex-row align-items-center gap-2 p-3 rounded border border-danger" style="background: rgba(220, 53, 69, 0.06);"
			 *ngIf="!noScopePermission && wizardInfo?.permissions && !wizardInfo.permissions.outbound">
			<i class="far fa-exclamation-circle text-danger" style="font-size: 1.2rem;"></i>
			<span class="text-danger" style="font-size: 13px;">You do not have permission to configure outbound protection. Please contact your administrator.</span>
		</div>

		<!--CC: all scope cards in one row-->
		<div class="flex-row gap-3">
			<ng-container *ngFor="let scopeEntry of steps.environmentScope.protectionScopes | keyvalue: gs.returnZero">
				<div class="scope-card flex-column align-items-center gap-2 border border-2 rounded p-3 position-relative text-center"
					 style="overflow: visible;"
					 [ngClass]="{'border-primary shadow': steps.environmentScope.selectedScope === scopeEntry.value.key,
					 			 'border-secondary-subtle': steps.environmentScope.selectedScope !== scopeEntry.value.key,
					 			 'hvr-darken-light cursor-pointer': isScopeAllowed(scopeEntry.value.key),
					 			 'disabled-overlay': !isScopeAllowed(scopeEntry.value.key)}"
					 (click)="selectScope(scopeEntry.value.key)">
					<i class="far" style="position: absolute; top: 6px; left: 6px; font-size: 0.85rem;"
					   [ngClass]="{'fa-dot-circle text-primary': steps.environmentScope.selectedScope === scopeEntry.value.key,
					   			   'fa-circle text-muted': steps.environmentScope.selectedScope !== scopeEntry.value.key}"></i>
					<div class="flex-row align-items-center gap-2" *ngIf="scopeEntry.value.key === 'both'">
						<i class="far fa-inbox-in" style="font-size: 28px; color: #1a6fa0;"></i>
						<span style="font-size: 16px; font-weight: 300;">+</span>
						<i class="far fa-inbox-out" style="font-size: 28px; color: #7b2d8e;"></i>
					</div>
					<i class="far" *ngIf="scopeEntry.value.key !== 'both'"
					   [ngClass]="{'fa-inbox-in': scopeEntry.value.key === 'inbound',
					   			   'fa-inbox-out': scopeEntry.value.key === 'outbound'}"
					   [style.color]="scopeEntry.value.key === 'inbound' ? '#1a6fa0' : '#7b2d8e'"
					   style="font-size: 28px;"></i>
					<span class="fw-bold" style="font-size: 13px;">{{scopeEntry.value.label}}</span>
					<span class="text-muted" style="font-size: 11px;">{{scopeEntry.value.subtitle}}</span>
					<span class="badge text-success border border-success bg-white" style="font-size: 10px; position: absolute; top: -10px; right: -6px; z-index: 1;" *ngIf="scopeEntry.value.recommended && isScopeAllowed(scopeEntry.value.key)">Recommended</span>
					<!--CC: permission error badge-->
					<span class="text-danger" style="font-size: 10px;" *ngIf="!isScopeAllowed(scopeEntry.value.key)">
						<i class="far fa-lock" style="margin-right: 3px;"></i>No permission
					</span>
				</div>
			</ng-container>
		</div>

	</div>

	<!--CC: outbound architecture — compact selector cards + expanded detail below-->
	<div class="flex-column gap-4" *ngIf="activeStepKey === 'emailArchitecture' && activeSubStepKey === 'outboundArch'">

		<!--CC: card row — matches email-relay-integration card design-->
		<div class="flex-row justify-content-center gap-3 px-4 py-3">
			<ng-container *ngFor="let archEntry of outboundArchitectures | keyvalue: gs.returnZero">
				<div class="flex-row align-items-center position-relative" style="width: 220px; overflow: visible;"
						 *ngIf="activeOutboundArchSupport[archEntry.key]">
					<div class="flex-row f-1-0 gap-2 align-items-center border border-2 rounded py-3 px-3 hvr-darken-light cursor-pointer position-relative w-100"
						 style="white-space: nowrap;"
						 (click)="selectOutboundArchitecture(archEntry.key)"
						 [ngClass]="{'border-primary shadow' : archEntry.key === selectedOutboundArchitecture?.key,
						 			 'border-secondary-subtle' : archEntry.key !== selectedOutboundArchitecture?.key}">
						<i class="far" style="font-size: 0.9rem;"
						   [ngClass]="{'fa-dot-circle text-primary': archEntry.key === selectedOutboundArchitecture?.key,
						   			   'fa-circle text-muted': archEntry.key !== selectedOutboundArchitecture?.key}"></i>
						<i class="text-primary opacity-50" [ngClass]="archEntry.value.icon"></i>
						<span class="fw-bold"
							  [ngClass]="{'text-primary' : archEntry.key === selectedOutboundArchitecture?.key}">Via {{archEntry.value.shortName}}</span>
						<span class="badge text-success border border-success bg-white" style="font-size: 10px; position: absolute; top: -10px; right: -6px; z-index: 1;" *ngIf="activeOutboundArchSupport[archEntry.key] === 'recommended'">Recommended</span>
					</div>

				</div>
			</ng-container>
		</div>

		<!--CC: expanded detail panel for selected architecture-->
		<div class="flex-column gap-3 border rounded p-3 animated fadeIn" *ngIf="selectedOutboundArchitecture">
			<span class="lh-base">{{selectedOutboundArchitecture.description}}</span>

			<!--CC: mail flow steps-->
			<div class="flex-column gap-1">
				<b>Mail Flow</b>
				<div class="flex-column gap-1">
					<div class="flex-row align-items-center gap-2" *ngFor="let step of selectedOutboundArchitecture.mailFlow; let idx = index">
						<span class="d-flex align-items-center justify-content-center rounded-circle text-primary fw-bold"
							  style="width: 20px; height: 20px; min-width: 20px; font-size: 0.75em; border: 1px solid var(--bs-primary);">{{idx + 1}}</span>
						<span>{{step}}</span>
					</div>
				</div>
			</div>

			<flow-diagram-c [spec]="outboundPreviewSpec"></flow-diagram-c>

		</div>
	</div>

	<!--CC: inbound architecture — compact selector cards + expanded detail below-->
	<div class="flex-column gap-4" *ngIf="activeStepKey === 'emailArchitecture' && activeSubStepKey === 'inboundArch'">

		<!--CC: card row — one card per inbound architecture-->
		<div class="flex-row justify-content-center gap-3 px-4 py-3">
			<ng-container *ngFor="let archEntry of inboundArchitectures | keyvalue: gs.returnZero">
				<div class="flex-row align-items-center position-relative" style="width: 220px; overflow: visible;"
						 *ngIf="activeInboundArchSupport[archEntry.key]">
					<div class="flex-row f-1-0 gap-2 align-items-center border border-2 rounded py-3 px-3 hvr-darken-light cursor-pointer position-relative w-100"
						 style="white-space: nowrap;"
						 (click)="selectInboundArchitecture(archEntry.key)"
						 [ngClass]="{'border-primary shadow' : archEntry.key === selectedInboundArchitecture?.key,
						 			 'border-secondary-subtle' : archEntry.key !== selectedInboundArchitecture?.key}">
						<i class="far" style="font-size: 0.9rem;"
						   [ngClass]="{'fa-dot-circle text-primary': archEntry.key === selectedInboundArchitecture?.key,
						   			   'fa-circle text-muted': archEntry.key !== selectedInboundArchitecture?.key}"></i>
						<i class="text-primary opacity-50" [ngClass]="archEntry.value.icon"></i>
						<span class="fw-bold"
							  [ngClass]="{'text-primary' : archEntry.key === selectedInboundArchitecture?.key}">Via {{archEntry.value.shortName}}</span>
						<span class="badge text-success border border-success bg-white" style="font-size: 10px; position: absolute; top: -10px; right: -6px; z-index: 1;" *ngIf="activeInboundArchSupport[archEntry.key] === 'recommended'">Recommended</span>
					</div>

				</div>
			</ng-container>
		</div>

		<!--CC: expanded detail panel for selected inbound architecture-->
		<div class="flex-column gap-3 border rounded p-3 animated fadeIn" *ngIf="selectedInboundArchitecture">
			<span class="lh-base">{{selectedInboundArchitecture.description}}</span>

			<!--CC: mail flow steps-->
			<div class="flex-column gap-2">
				<b>Mail Flow</b>
				<div class="flex-column gap-1">
					<div class="flex-row align-items-center gap-2" *ngFor="let step of selectedInboundArchitecture.mailFlow; let idx = index">
						<span class="d-flex align-items-center justify-content-center rounded-circle text-primary fw-bold"
							  style="width: 20px; height: 20px; min-width: 20px; font-size: 0.75em; border: 1px solid var(--bs-primary);">{{idx + 1}}</span>
						<span>{{step}}</span>
					</div>
				</div>
			</div>

			<flow-diagram-c [spec]="inboundPreviewSpec"></flow-diagram-c>
		</div>
	</div>

	<!--Mail server API — Exchange, GSuite, or LDAP based on selected email service-->
	<ng-container *ngIf="activeStepKey === 'mailServer' && activeSubStepKey === 'connectEmailIntegration'">
		<onboarding-connect-api-integration-component style="display: contents;"
			[integrationType]="dic.CONSTANTS.integrationType.gsuite"
			*ngIf="steps.environmentScope.selectedEmailService === dic.CONSTANTS.onboardingFormValues.currentEnv.gSuite">
		</onboarding-connect-api-integration-component>
		<onboarding-connect-api-integration-component style="display: contents;"
			[integrationType]="dic.CONSTANTS.integrationType.exchange"
			*ngIf="steps.environmentScope.selectedEmailService === dic.CONSTANTS.onboardingFormValues.currentEnv.exchangeCloud ||
				steps.environmentScope.selectedEmailService === dic.CONSTANTS.onboardingFormValues.currentEnv.hybrid">
		</onboarding-connect-api-integration-component>
		<onboarding-connect-api-integration-component style="display: contents;"
			[integrationType]="dic.CONSTANTS.integrationType.ldap"
			*ngIf="steps.environmentScope.selectedEmailService === dic.CONSTANTS.onboardingFormValues.currentEnv.onPermises">
		</onboarding-connect-api-integration-component>
	</ng-container>

	<!--Configure domains-->
	<onboarding-domains-component style="display: contents;"
		*ngIf="activeStepKey === 'configureDomains' && activeSubStepKey === 'domains'">
	</onboarding-domains-component>

	<!--CC: general settings — region + time zone + welcome email, all inline-->
	<div class="list-group list-group-flush settings-list-container" *ngIf="activeStepKey === 'generalSettings' && activeSubStepKey === 'settings'">

		<div class="list-group-item settings-list-item" *ngIf="userInfo">
			<div class="title-section-container flex-column gap-2">
				<b>Region</b>
				<span style="font-size: 0.9em;">Selecting a new region will change where new secure data is stored, but will not affect existing data.</span>
			</div>
			<div class="content-container flex-column justify-content-center">
				<app-dropdown-c style="width: 210px;" [text]="userInfo?.plan.use_region">
					<li *ngFor="let region of regions"
						(click)="changeRegion(region)">
						{{region}}
					</li>
				</app-dropdown-c>
			</div>
		</div>

		<!--CC: taken from my-profile.component.html -> Select Time Zone for Reports-->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Select Time Zone for Reports</b>
				<span style="font-size: 0.9em;">
					This time zone will be used to show dates and times for reports sent by the system, such as quarantined email reports
				</span>
			</div>
			<div class="content-container flex-column gap-2">
				<app-dropdown-c style="width: 250px;"
								text="{{selectedTimeZone?.label || 'Select'}}"
								[enableSearch]="true"
								itemDisplayKey="label"
								[items]="timeZones"
								(onItemClicked)="updateUserTimezone($event.item)"></app-dropdown-c>
			</div>
		</div>

		<div class="list-group-item settings-list-item" *ngIf="outboundSelected">
			<div class="title-section-container flex-column gap-2">
				<b>Send welcome email to new users</b>
				<span style="font-size: 0.9em;">
					Users who join your plan via the Email Relay will receive a "welcome" email and admins will be notified.
				</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c
					[(model)]="wizardInfo.outbound_relay.welcome_email.enabled"
					(onChange)="updateSendWelcomeSettings('enabled')">
				</toggle-switch-c>
			</div>
		</div>

	</div>

	<!--General settings — branding-->
	<look-and-feel-component style="display: contents;"
		*ngIf="activeStepKey === 'generalSettings' && activeSubStepKey === 'branding'"
		[isEmbedded]="true"
		(saveDone)="proceedToNextStep()">
	</look-and-feel-component>

	<!--General settings — copy policy-->
	<onboarding-copy-policy-component style="display: contents;"
		*ngIf="activeStepKey === 'generalSettings' && activeSubStepKey === 'copyPolicy'"
		(done)="proceedToNextStep()">
	</onboarding-copy-policy-component>

	<!--Outbound Shield — rules-->
	<outbound-rules-component style="display: contents;"
		*ngIf="activeStepKey === 'outboundShield' && activeSubStepKey === 'rules'">
	</outbound-rules-component>

	<!--Outbound Shield — policies-->
	<outbound-policies-component style="display: contents;"
		*ngIf="activeStepKey === 'outboundShield' && activeSubStepKey === 'policies'">
	</outbound-policies-component>

	<!--Deploy Outbound Shield — powershell + docs-->
	<div class="flex-column gap-4" *ngIf="activeStepKey === 'deployOutboundShield' && activeSubStepKey === 'deploy'">

		<!--CC: deploy mode selector boxes-->
		<div class="flex-row justify-content-center gap-3 px-4">
			<div class="flex-row f-1-0 gap-2 align-items-center border border-2 rounded py-3 px-3 hvr-darken-light cursor-pointer"
				 style="max-width: 260px; white-space: nowrap;"
				 *ngIf="isPsAvailable"
				 (click)="outboundDeployMode = 'automatic'"
				 [ngClass]="{'border-primary shadow' : outboundDeployMode === 'automatic',
							 'border-secondary-subtle' : outboundDeployMode !== 'automatic'}">
				<i class="far" style="font-size: 0.9rem;"
				   [ngClass]="{'fa-dot-circle text-primary': outboundDeployMode === 'automatic',
				   			   'fa-circle text-muted': outboundDeployMode !== 'automatic'}"></i>
				<i class="far fa-magic text-primary opacity-50"></i>
				<span class="fw-bold" [ngClass]="{'text-primary' : outboundDeployMode === 'automatic'}">Automatic Deployment</span>
			</div>
			<div class="flex-row f-1-0 gap-2 align-items-center border border-2 rounded py-3 px-3 hvr-darken-light cursor-pointer"
				 style="max-width: 260px; white-space: nowrap;"
				 (click)="outboundDeployMode = 'manual'"
				 [ngClass]="{'border-primary shadow' : outboundDeployMode === 'manual',
							 'border-secondary-subtle' : outboundDeployMode !== 'manual'}">
				<i class="far" style="font-size: 0.9rem;"
				   [ngClass]="{'fa-dot-circle text-primary': outboundDeployMode === 'manual',
				   			   'fa-circle text-muted': outboundDeployMode !== 'manual'}"></i>
				<i class="far fa-wrench text-primary opacity-50"></i>
				<span class="fw-bold" [ngClass]="{'text-primary' : outboundDeployMode === 'manual'}">Manual Deployment</span>
			</div>
		</div>

		<!--CC: automatic deploy — powershell wizard-->
		<onboarding-powershell-integration-component
			*ngIf="outboundDeployMode === 'automatic'"
			style="display: contents;"
			pageOrigin="outbound">
		</onboarding-powershell-integration-component>

		<!--CC: manual deploy — credentials, MTA, guides-->
		<ng-container *ngIf="outboundDeployMode === 'manual'">


		<!--CC: manual deploy doc link-->
		<div class="flex-row align-items-center justify-content-center gap-1 p-3 rounded" style="background: var(--bs-light);" *ngIf="activeOutboundGuides.length">
			<span>Complete the deployment manually by following the steps in this</span>
			<a class="blue-link flex-row align-items-center gap-1 fw-bold" target="_blank" [href]="activeOutboundGuides[0].url" rel="noopener noreferrer">
				<span>technical doc</span>
				<i class="far fa-external-link" style="font-size: 10px;"></i>
			</a>
		</div>
		<ng-container *ngIf="confirmedOutboundArch === dic.CONSTANTS.sendingArchitecture.journal">
			<div class="list-group-item settings-list-item" style="border: none;">
				<div class="title-section-container flex-column gap-2">
					<b>Journal Rule Settings</b>
					<span class="lh-base" style="font-size: 0.9em;">
						Configure the Journal Rule settings in <a class="blue-link" href="https://purview.microsoft.com/datalifecyclemanagement/exchange/journalrules" target="_blank">Exchange</a> or Google Workspace to scan your journaled emails in Trustifi.
						<br/><br/>
						*To scan journaled emails from domains other than the primary domain ({{gs.getDomainDisplay(userInfo?.email)}}), verify the <a class="blue-link" target="_blank" [href]="'/' + dic.CONSTANTS.appStates.adminInbound + '/' + dic.CONSTANTS.adminPages.inbound.plan + '/' + dic.CONSTANTS.inboundPlanSettingsPageTabs.domains">domain</a> or connect to the Exchange/Google API integration.
					</span>
				</div>
				<div class="content-container flex-column gap-5">
					<div class="flex-row align-items-center gap-3">
						<span class="fw-bold" style="flex-basis: 55px; font-size: 0.9em;">Email:</span>
						<input class="f-1-0 border-0 p-0" style="font-size: 12px; background: inherit;"
							   [type]="showJournalAddress ? 'text' : 'password'"
							   [ngStyle]="{'letter-spacing' : showJournalAddress ? 'normal' : '2.4px'}"
							   [ngClass]="{'nofill': !showJournalAddress}"
							   [(ngModel)]="wizardInfo.outbound_relay.journalEmailAddress" disabled>
						<label class="hidepwd hvr-opacity" style="margin-bottom: 0; font-size: 1.2rem; cursor: pointer;"
							   [tooltip]="showJournalAddress ? 'Hide' : 'Show'">
							<input type="checkbox" [(ngModel)]="showJournalAddress"/>
							<i class="fas fa-eye unchecked"></i>
							<i class="fas fa-eye-slash checked"></i>
						</label>
						<a style="font-size: 1rem;"
						   (click)="gs.copyToClipboard(wizardInfo.outbound_relay.journalEmailAddress);" tooltip="Copy">
							<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
						</a>
					</div>
				</div>
			</div>
		</ng-container>

		<!--CC: MTA verification section in manual outbound deploy-->
		<div class="p-3 flex-column gap-3 rounded border" *ngIf="confirmedOutboundArch === dic.CONSTANTS.sendingArchitecture.client">
			<div class="flex-column gap-2">
				<b>MTA Configuration</b>
				<span class="lh-base" style="font-size: 0.9em;">Verify that your MTA endpoints are reachable and correctly configured before deploying outbound protection.</span>
			</div>
			<onboarding-mta-component style="display: contents;" [relay]="wizardInfo.outbound_relay"></onboarding-mta-component>
		</div>

		<ng-container *ngIf="confirmedOutboundArch === dic.CONSTANTS.sendingArchitecture.trustifi ||
			confirmedOutboundArch === dic.CONSTANTS.sendingArchitecture.client">
			<div class="flex-column gap-4">
				<div class="p-3 flex-column gap-4 rounded border">
					<div class="flex-row justify-content-between">
						<span class="fw-bold" style="font-size: 0.9rem;">Email Relay Credentials</span>
					</div>
					<div class="flex-column gap-2">
						<div class="flex-row justify-content-between align-items-center">
							<div class="flex-row gap-3 align-items-center f-1-0">
								<span class="fw-bold" style="flex-basis: 120px; font-size: 0.9em;">Header:</span>
								<span>{{emailRelayHeader}}</span>
							</div>
							<a style="font-size: 1rem;" (click)="gs.copyToClipboard(emailRelayHeader);"
							   tooltip="Copy Email Relay Header">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
						<div class="flex-row align-items-center gap-3">
							<span class="fw-bold" style="flex-basis: 120px; font-size: 0.9em;">Primary Key:</span>
							<input class="f-1-0 border-0 p-0" style="font-size: 12px; background: inherit;"
							       [type]="showEmailRelayKey ? 'text' : 'password'"
							       [ngStyle]="{'letter-spacing' : showEmailRelayKey ? 'normal' : '2.4px'}"
							       [ngClass]="{'nofill': !showEmailRelayKey}"
							       [(ngModel)]="wizardInfo.outbound_relay.keyAndSecret" disabled>
							<label class="hidepwd hvr-opacity" style="margin-bottom: 0; font-size: 1.2rem; cursor: pointer;"
							       [tooltip]="showEmailRelayKey ? 'Hide key' : 'Show key'">
								<input type="checkbox" [(ngModel)]="showEmailRelayKey"/>
								<i class="fas fa-eye unchecked"></i>
								<i class="fas fa-eye-slash checked"></i>
							</label>
							<a class="blue-link copy-link hSpace05" style="font-size: 11px;"
							   (click)="regenerateEmailRelayKey(1);"
							   tooltip="Regenerate key for the Email Relay">
								<i style="cursor: pointer; color: black;" [ngClass]="regenerateInProcessER ? 'far fa-spinner fa-spin' : 'far fa-sync-alt'"></i>
							</a>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard(wizardInfo.outbound_relay.key + ':' + wizardInfo.outbound_relay.secret);"
							   tooltip="Copy Email Relay Key">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
					</div>

					<div class="line-container">
						<hr class="custom-line">
						<div class="line-text">OR</div>
					</div>

					<div class="flex-row justify-content-between">
						<span class="fw-bold" style="font-size: 0.9rem;">SMTP Credentials Authentication</span>
					</div>
					<div class="flex-column gap-1">
						<div class="flex-row align-items-center gap-3" style="height: 30px;">
							<span class="fw-bold" style="flex-basis: 130px; font-size: 0.9em;">Host:</span>
							<span class="f-1-0">smtp.trustifi.com</span>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard('smtp.trustifi.com');"
							   tooltip="Copy Email Relay Host">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
						<div class="flex-row align-items-center gap-3" style="height: 30px;">
							<span class="fw-bold" style="flex-basis: 130px; font-size: 0.9em;">Port:</span>
							<span class="f-1-0">25<sup style="margin-left: 5px; color: green;">(StartTLS)</sup></span>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard('25');"
							   tooltip="Copy Email Relay Port">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
						<div class="flex-row align-items-center gap-3">
							<span class="fw-bold" style="flex-basis: 130px; font-size: 0.9em;">Username:</span>
							<input class="f-1-0 border-0 p-0" style="font-size: 12px; background: inherit;"
							       [type]="showEmailRelayUsername ? 'text' : 'password'"
							       [ngStyle]="{'letter-spacing' : showEmailRelayUsername ? 'normal' : '2.4px'}"
							       [ngClass]="{'nofill': !showEmailRelayUsername}"
							       [(ngModel)]="wizardInfo.outbound_relay.key" disabled>
							<label class="hidepwd hvr-opacity" style="margin-bottom: 0; font-size: 1.2rem; cursor: pointer;"
							       [tooltip]="showEmailRelayUsername ? 'Hide username' : 'Show username'">
								<input type="checkbox" [(ngModel)]="showEmailRelayUsername"/>
								<i class="fas fa-eye unchecked"></i>
								<i class="fas fa-eye-slash checked"></i>
							</label>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard(wizardInfo.outbound_relay.key);"
							   tooltip="Copy Email Relay Username">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
						<div class="flex-row align-items-center gap-3">
							<span class="fw-bold" style="flex-basis: 130px; font-size: 0.9em;">Primary Password:</span>
							<input class="f-1-0 border-0 p-0" style="font-size: 12px; background: inherit;"
							       [type]="showEmailRelayPassword ? 'text' : 'password'"
							       [ngStyle]="{'letter-spacing' : showEmailRelayPassword ? 'normal' : '2.4px'}"
							       [ngClass]="{'nofill': !showEmailRelayPassword}"
							       [(ngModel)]="wizardInfo.outbound_relay.secret" disabled>
							<label class="hidepwd hvr-opacity" style="margin-bottom: 0; font-size: 1.2rem; cursor: pointer;"
							       [tooltip]="showEmailRelayPassword ? 'Hide password' : 'Show password'">
								<input type="checkbox" [(ngModel)]="showEmailRelayPassword"/>
								<i class="fas fa-eye unchecked"></i>
								<i class="fas fa-eye-slash checked"></i>
							</label>
							<a class="blue-link copy-link hSpace05" style="font-size: 11px;"
							   (click)="regenerateEmailRelayKey(1);"
							   tooltip="Regenerate key for the Email Relay">
								<i style="cursor: pointer; color: black;" [ngClass]="regenerateInProcessER ? 'far fa-spinner fa-spin' : 'far fa-sync-alt'"></i>
							</a>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard(wizardInfo.outbound_relay.secret);"
							   tooltip="Copy Email Relay Password">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

		<!-- CC: taken from email-relay-integration.component.html -> IP Address Set -->
		<div class="p-3 flex-column gap-4 rounded border"
			 *ngIf="(confirmedOutboundArch === dic.CONSTANTS.sendingArchitecture.trustifi || confirmedOutboundArch === dic.CONSTANTS.sendingArchitecture.client) && wizardInfo?.outbound_relay?.static_ip_set_ips?.length">
			<div class="flex-column gap-2">
				<b>IP Address Set (Region: {{wizardInfo.outbound_relay.static_ip_region || 'US default'}} | Skip Certificate Validation: {{!!wizardInfo.outbound_relay.static_ip_skip_unauthorized}})</b>
				<span class="lh-base" style="font-size: 0.9em;">
					{{confirmedOutboundArch === dic.CONSTANTS.sendingArchitecture.client
						? 'IP addresses that will be used to deliver emails back to your MTA.'
						: 'IP addresses that will be used to deliver emails to recipients.'}}
				</span>
				<span class="lh-base" style="font-size: 0.9em;"><span style="color: darkorange;">NOTE:</span> For the assurance of email delivery, it is <b>recommended</b> to add these IPs to your Firewall/SEG appliances.</span>
			</div>
			<div class="flex-column gap-2">
				<span *ngFor="let ip of wizardInfo.outbound_relay.static_ip_set_ips">
					- {{ip}} <a style="font-size: 0.9rem;" (click)="gs.copyToClipboard(ip);" tooltip="Copy IP">
						<i class="copy-link far fa-copy" style="cursor: pointer;"></i>
					</a>
				</span>
			</div>
		</div>

		</ng-container>

	</div>

	<!--CC: verify MTA substep — shown only for 'Your MTA' architecture-->
	<onboarding-mta-component style="display: contents;"
		*ngIf="activeStepKey === 'deployOutboundShield' && activeSubStepKey === 'verifyMta'"
		[relay]="wizardInfo.outbound_relay">
	</onboarding-mta-component>

	<!--CC: outbound verify step — polls email trace for recent outbound emails-->
	<div class="flex-column gap-3 align-items-center" *ngIf="activeStepKey === 'deployOutboundShield' && activeSubStepKey === 'verify'">
		<div class="flex-column gap-1 align-items-center text-center" style="max-width: 600px;">
			<span class="fw-bold" style="font-size: 1.1rem;"><i class="far fa-paper-plane text-primary me-2"></i>Send a test email</span>
			<span class="text-muted lh-base" style="font-size: 0.9rem;">Send an outbound email from your mail system to verify that it is being routed through Trustifi. The trace will update automatically once the email is detected.</span>
		</div>

		<div class="flex-column gap-2 align-items-center" *ngIf="verifyTraceInProcess && !verifyTraceResults?.length">
			<search-email-loader style="transform: scale(0.7);" class="animated fadeIn"></search-email-loader>
			<span class="text-muted loading-dots" style="font-size: 0.85rem;">Waiting for emails</span>
		</div>

		<div class="flex-column gap-3 w-100 animated fadeIn" *ngIf="verifyTraceResults?.length">
			<div class="flex-row gap-3 align-items-center p-3 rounded" style="background: rgba(25, 135, 84, 0.08);" *ngIf="!verifyTraceInProcess">
				<i class="far fa-shield-check text-success" style="font-size: 1.5rem;"></i>
				<div class="flex-column gap-1">
					<span class="fw-bold text-success">Email architecture configured successfully</span>
					<span class="text-muted" style="font-size: 0.85rem;">Emails are flowing through Trustifi and being processed correctly.</span>
				</div>
			</div>
			<div class="flex-row align-items-center gap-2" *ngIf="verifyTraceInProcess">
				<loader-c class="animated fadeIn" style="width: 15px; height: 15px;"></loader-c>
				<span class="text-muted" style="font-size: 0.85rem;">Email detected, waiting for processing to complete...</span>
			</div>
			<div class="border rounded p-2">
				<table class="w-100 simpleDataTable" cellpadding="5">
					<thead>
						<tr>
							<th>Sender</th>
							<th>Recipient</th>
							<th>Subject</th>
							<th>Date</th>
							<th style="text-align: center;">Status</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let traceItem of verifyTraceResults">
							<td>{{traceItem.from}}</td>
							<td>{{traceItem.rcptTo}}</td>
							<td>{{traceItem.subject || 'None'}}</td>
							<td>{{traceItem.created | date: 'MM/dd/yyyy HH:mm'}}</td>
							<td style="text-align: center;">
								<i [ngClass]="traceItem.status === 'Completed' ? 'far fa-check-circle' : traceItem.status === 'Quarantined' ? 'far fa-bug' : traceItem.status === 'Failed' ? 'far fa-times-circle' : 'far fa-clock'"
								   [tooltip]="traceItem.status"
								   [ngStyle]="{'color' : traceItem.status === 'Completed' ? 'darkgreen' : traceItem.status === 'Quarantined' || traceItem.status === 'Failed' ? 'red' : 'grey'}"></i>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!--CC: taken from email-trace.component.html -> trace logs display-->
			<div class="flex-column gap-1 border rounded p-3" style="background: #fafafa; font-size: 0.85rem;"
				 *ngIf="verifyTraceResults[0]?.text?.length">
				<div class="flex-row gap-1" *ngFor="let message of verifyTraceResults[0].text">
					<span class="fw-bold flex-shrink-0" *ngIf="message.timestamp">{{message.timestamp | date:'MM/dd/yyyy HH:mm:ss'}}:</span>
					<span *ngIf="message.log">{{message.log}}</span>
				</div>
			</div>
		</div>
	</div>

	<!--Inbound Shield — threat prevention-->
	<threat-prevention-component class="o-wizard-inner-component" style="display: contents;"
								 *ngIf="activeStepKey === 'inboundShield' && activeSubStepKey === 'threatPreventionRules'">
	</threat-prevention-component>

	<!--Inbound Shield — smart banner-->
	<security-awareness-component style="display: contents;"
								  *ngIf="activeStepKey === 'inboundShield' && activeSubStepKey === 'smartBanner'">
	</security-awareness-component>

	<!--CC: Inbound Shield — reviewers-->
	<onboarding-reviewers-component style="display: contents;"
									*ngIf="activeStepKey === 'inboundShield' && activeSubStepKey === 'reviewers'">
	</onboarding-reviewers-component>

	<!--Inbound Shield — notification options-->
	<notification-options-component style="display: contents;"
									*ngIf="activeStepKey === 'inboundShield' && activeSubStepKey === 'notificationOptions' && mainRulePreset"
									[mainRulePreset]="mainRulePreset"
									[isEmbedded]="true"
									(closeCb)="proceedToNextStep()">
	</notification-options-component>

	<!--CC: Inbound Shield — additional settings-->
	<div class="list-group list-group-flush settings-list-container" *ngIf="activeStepKey === 'inboundShield' && activeSubStepKey === 'additionalSettings'">

		<!--CC: taken from inbound-configuration.component.html -> On-click Link Scan (without the quarantine notification settings)-->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>On-click Link Scan</b>
				<span class="lh-base" style="font-size: 0.9em;">Scans each clicked link in real time for phishing and malicious content, and rewrites the URL for secure inspection before access.<br/>
					Full documentation can be found <a href="https://docs.trustifi.com/docs/on-click-scan" target="_blank">here</a>.
				</span>
			</div>
			<div class="content-container flex-column gap-3" *ngIf="wizardInfo.threat_protection.url_rewrite">
				<toggle-switch-c id="onboardingOnClickLinkScanToggle"
								 [(model)]="wizardInfo.threat_protection.url_rewrite.enabled"
								 (onChange)="changeOnClickScanStatus()"
								 [isDisabled]="updateUrlRewriteSettingsInProcess">
				</toggle-switch-c>
				<div class="flex-row gap-3 align-items-center">
					<span>Allow users to continue to URLs blocked by on-click scan</span>
					<toggle-switch-c id="onboardingAllowContinueToURLToggle"
									 [(model)]="wizardInfo.threat_protection.url_rewrite.allow_malicious_onclick"
									 (onChange)="updateUrlRewriteSettings(dic.CONSTANTS.inboundUrlRewriteActions.allowMaliciousOnClick)"
									 [isDisabled]="!wizardInfo.threat_protection.url_rewrite.enabled || updateUrlRewriteSettingsInProcess"
									 [hideText]="true">
					</toggle-switch-c>
				</div>
			</div>
		</div>

		<!--CC: taken from inbound-configuration.component.html -> URL Hunting (the link to the URL Hunting page is dropped - it would navigate out of the wizard)-->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>URL Hunting</b>
				<span class="lh-base" style="font-size: 0.9em;">The URL Hunting tool allows security teams to track and identify users who clicked on scanned links, and provide additional details like the specific location and browser/device that was used when the link was clicked.</span>
			</div>
			<div class="content-container flex-column gap-3" *ngIf="wizardInfo.threat_protection.url_rewrite">
				<toggle-switch-c id="onboardingUrlHuntingToggle"
								 [(model)]="wizardInfo.threat_protection.url_rewrite.url_tracking"
								 (onChange)="updateUrlRewriteSettings(dic.CONSTANTS.inboundUrlRewriteActions.urlHunting)"
								 [isDisabled]="updateUrlRewriteSettingsInProcess">
				</toggle-switch-c>
			</div>
		</div>

		<!--CC: taken from threat-prevention-rules.component.html -> Apply "Scanned by Inbound Shield" footer-->
		<div class="list-group-item settings-list-item">
			<div class="title-section-container flex-column gap-2">
				<b>Apply "Scanned by Inbound Shield" footer</b>
				<span class="lh-base" style="font-size: 0.9em;">When enabled, a footer will be applied to all emails to indicate the email has been scanned by Inbound Shield.</span>
			</div>
			<div class="content-container flex-column gap-3">
				<toggle-switch-c id="onboardingApplyFooterToggle"
								 [(model)]="wizardInfo.threat_protection.add_footer"
								 (onChange)="updateFooterStatus()">
				</toggle-switch-c>
				<div class="flex-row align-items-center gap-2" [ngClass]="{'disabled-overlay' : !wizardInfo.threat_protection.add_footer}">
					<span>Customized footer:</span>
					<input type="text" class="f-1-0"
						   [disabled]="!wizardInfo.threat_protection.add_footer"
						   placeholder='Default: "This email has been scanned by Inbound Shield"'
						   [(ngModel)]="wizardInfo.threat_protection.customization_footer"/>
					<btn-c (action)="updateFooterContent();">
						Update
					</btn-c>
				</div>
			</div>
		</div>
	</div>

	<!--CC: verify MTA substep for inbound — shown for connector and mx architectures-->
	<onboarding-mta-component style="display: contents;"
		*ngIf="activeStepKey === 'deployInboundShield' && activeSubStepKey === 'verifyMta'"
		[relay]="wizardInfo.inbound_relay"
		direction="inbound">
	</onboarding-mta-component>

	<!--CC: Selective Mailbox Protection substep (MX only, see updateStepVisibility) - same component as Plan Settings > Email Flow Integration-->
	<div class="flex-column gap-4 f-1-0" *ngIf="activeStepKey === 'deployInboundShield' && activeSubStepKey === 'mailboxes'">
		<div class="p-3 flex-column gap-3 rounded border" *ngIf="wizardInfo?.inbound_relay">
			<selective-mailbox-protection-component style="display: contents;" [relay]="wizardInfo.inbound_relay" [hideTitle]="true" idPrefix="wizard_"></selective-mailbox-protection-component>
		</div>
	</div>

	<div class="flex-column gap-4 f-1-0" *ngIf="activeStepKey === 'deployInboundShield' && activeSubStepKey === 'deploy'">
		<!--CC: Graph API architecture — show mailbox management directly -->
		<onboarding-mailboxes-component class="flxClmn f-1-0"
			*ngIf="confirmedInboundArch === dic.CONSTANTS.inboundSendingArchitecture.graph"
			(done)="proceedToNextStep()">
		</onboarding-mailboxes-component>

		<!--CC: deploy mode selector boxes (hidden for graph — has its own component) -->
		<div class="flex-row justify-content-center gap-3 px-4" *ngIf="confirmedInboundArch !== dic.CONSTANTS.inboundSendingArchitecture.graph">
			<div class="flex-row f-1-0 gap-2 align-items-center border border-2 rounded py-3 px-3 hvr-darken-light cursor-pointer"
				 style="max-width: 260px; white-space: nowrap;"
				 *ngIf="isPsAvailable"
				 (click)="inboundDeployMode = 'automatic'"
				 [ngClass]="{'border-primary shadow' : inboundDeployMode === 'automatic',
							 'border-secondary-subtle' : inboundDeployMode !== 'automatic'}">
				<i class="far" style="font-size: 0.9rem;"
				   [ngClass]="{'fa-dot-circle text-primary': inboundDeployMode === 'automatic',
				   			   'fa-circle text-muted': inboundDeployMode !== 'automatic'}"></i>
				<i class="far fa-magic text-primary opacity-50"></i>
				<span class="fw-bold" [ngClass]="{'text-primary' : inboundDeployMode === 'automatic'}">Automatic Deployment</span>
			</div>
			<div class="flex-row f-1-0 gap-2 align-items-center border border-2 rounded py-3 px-3 hvr-darken-light cursor-pointer"
				 style="max-width: 260px; white-space: nowrap;"
				 (click)="inboundDeployMode = 'manual'"
				 [ngClass]="{'border-primary shadow' : inboundDeployMode === 'manual',
							 'border-secondary-subtle' : inboundDeployMode !== 'manual'}">
				<i class="far" style="font-size: 0.9rem;"
				   [ngClass]="{'fa-dot-circle text-primary': inboundDeployMode === 'manual',
				   			   'fa-circle text-muted': inboundDeployMode !== 'manual'}"></i>
				<i class="far fa-wrench text-primary opacity-50"></i>
				<span class="fw-bold" [ngClass]="{'text-primary' : inboundDeployMode === 'manual'}">Manual Deployment</span>
			</div>
		</div>

		<!--CC: automatic deploy — powershell wizard-->
		<ng-container *ngIf="inboundDeployMode === 'automatic'">
		<onboarding-powershell-integration-component
			class="animated fadeIn"
			style="display: contents;"
			pageOrigin="inbound">
		</onboarding-powershell-integration-component>
		</ng-container>

		<!--CC: manual deploy — credentials, MTA, guides-->
		<ng-container *ngIf="inboundDeployMode === 'manual'">


		<!--CC: manual deploy doc link-->
		<div class="flex-row align-items-center justify-content-center gap-1 p-3 rounded" style="background: var(--bs-light);" *ngIf="activeInboundGuides.length">
			<span>Complete the deployment manually by following the steps in this</span>
			<a class="blue-link flex-row align-items-center gap-1 fw-bold" target="_blank" [href]="activeInboundGuides[0].url" rel="noopener noreferrer">
				<span>technical doc</span>
				<i class="far fa-external-link" style="font-size: 10px;"></i>
			</a>
		</div>
		<!-- CC: taken from inbound-email-relay-integration.component.html -> Configure MX connection -->
		<div class="p-3 flex-column gap-4 rounded border" *ngIf="confirmedInboundArch === dic.CONSTANTS.inboundSendingArchitecture.mx">
			<div class="flex-column gap-2">
				<b>Configure MX connection</b>
				<span class="lh-base" style="font-size: 0.9em;">Follow the steps detailed here to configure your inbound mail flow with Trustifi via MX record.</span>
			</div>
			<div class="flex-column gap-3">
				<ul class="ps-3 mb-0" style="list-style-type: circle; line-height: 1.4;">
					<li>
						<span>All integrated domains must first be verified with Trustifi. You can start this process in <a class="blue-link text-nowrap" target="_blank" [routerLink]="['/' + dic.CONSTANTS.appStates.adminInbound, dic.CONSTANTS.adminPages.inbound.plan, dic.CONSTANTS.inboundPlanSettingsPageTabs.domains]">"Domains" tab</a>.<br/>
							You can view our <a class="blue-link text-nowrap" target="_blank" href="https://docs.trustifi.com/docs/domain-verification">Domain Verification Guide</a> for detailed instructions.
						</span>
					</li>
					<li>
						<span>To start routing your inbound mail flow to Trustifi, update your existing MX record to the Trustifi MX below in your DNS management system.</span>
					</li>
				</ul>
				<div class="flex-row align-items-baseline gap-2">
					<i class="far fa-info-circle text-info"></i>
					<span>For more information and instructions about MX integration please refer to our <a class="blue-link text-nowrap" href="https://docs.trustifi.com/docs/configuration-6" target="_blank">MX integration guide</a>.</span>
				</div>
				<div class="p-3 rounded border flex-row gap-2 align-items-center" >
					<span><b>Trustifi MX record</b>: {{wizardInfo.inbound_relay.mx}}</span>
					<a style="font-size: 0.9rem;" (click)="gs.copyToClipboard(wizardInfo.inbound_relay.mx);" tooltip="Copy the MX record">
						<i class="copy-link far fa-copy" style="cursor: pointer;"></i>
					</a>
				</div>
			</div>
		</div>
		<!-- CC: taken from inbound-email-relay-integration.component.html -> Journal Rule Settings -->
		<ng-container *ngIf="confirmedInboundArch === dic.CONSTANTS.inboundSendingArchitecture.journal">
			<div class="list-group-item settings-list-item" style="border: none;">
				<div class="title-section-container flex-column gap-2">
					<b>Journal Rule Settings</b>
					<span class="lh-base" style="font-size: 0.9em;">
						Configure the Journal Rule settings in <a class="blue-link" href="https://purview.microsoft.com/datalifecyclemanagement/exchange/journalrules" target="_blank">Exchange</a> or Google Workspace to scan your journaled emails in Trustifi.
						<br/><br/>
						*To scan journaled emails from domains other than the primary domain ({{gs.getDomainDisplay(userInfo?.email)}}), verify the <a class="blue-link" target="_blank" [href]="'/' + dic.CONSTANTS.appStates.adminInbound + '/' + dic.CONSTANTS.adminPages.inbound.plan + '/' + dic.CONSTANTS.inboundPlanSettingsPageTabs.domains">domain</a> or connect to the Exchange/Google API integration.
					</span>
				</div>
				<div class="content-container flex-column gap-5">
					<div class="flex-row align-items-center gap-3">
						<span class="fw-bold" style="flex-basis: 55px; font-size: 0.9em;">Email:</span>
						<input class="f-1-0 border-0 p-0" style="font-size: 12px; background: inherit;"
							   [type]="showInboundJournalAddress ? 'text' : 'password'"
							   [ngStyle]="{'letter-spacing' : showInboundJournalAddress ? 'normal' : '2.4px'}"
							   [ngClass]="{'nofill': !showInboundJournalAddress}"
							   [(ngModel)]="wizardInfo.inbound_relay.journalEmailAddress" disabled>
						<label class="hidepwd hvr-opacity" style="margin-bottom: 0; font-size: 1.2rem; cursor: pointer;"
							   [tooltip]="showInboundJournalAddress ? 'Hide' : 'Show'">
							<input type="checkbox" [(ngModel)]="showInboundJournalAddress"/>
							<i class="fas fa-eye unchecked"></i>
							<i class="fas fa-eye-slash checked"></i>
						</label>
						<a style="font-size: 1rem;"
						   (click)="gs.copyToClipboard(wizardInfo.inbound_relay.journalEmailAddress);" tooltip="Copy">
							<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
						</a>
					</div>
				</div>
			</div>
		</ng-container>

		<!--CC: MTA verification section in manual inbound deploy-->
		<div class="p-3 flex-column gap-3 rounded border" *ngIf="confirmedInboundArch === dic.CONSTANTS.inboundSendingArchitecture.mx || confirmedInboundArch === dic.CONSTANTS.inboundSendingArchitecture.connector">
			<div class="flex-column gap-2">
				<b>MTA Configuration</b>
				<span class="lh-base" style="font-size: 0.9em;">Verify that your MTA endpoints are reachable and correctly configured before deploying inbound protection.</span>
			</div>
			<onboarding-mta-component style="display: contents;" [relay]="wizardInfo.inbound_relay" direction="inbound"></onboarding-mta-component>
		</div>

		<!-- CC: taken from inbound-email-relay-integration.component.html -> Enable Relay & Credentials -->
		<ng-container *ngIf="confirmedInboundArch === dic.CONSTANTS.inboundSendingArchitecture.connector && wizardInfo?.inbound_relay">
			<div class="flex-column gap-4">
				<div class="p-3 flex-column gap-4 rounded border">
					<div class="flex-row justify-content-between">
						<span class="fw-bold" style="font-size: 0.9rem;">Email Relay Credentials</span>
					</div>
					<div class="flex-column gap-2">
						<div class="flex-row justify-content-between align-items-center">
							<div class="flex-row gap-3 align-items-center f-1-0">
								<span class="fw-bold" style="flex-basis: 120px; font-size: 0.9em;">Header:</span>
								<span>{{inboundEmailRelayHeader}}</span>
							</div>
							<a style="font-size: 1rem;" (click)="gs.copyToClipboard(inboundEmailRelayHeader);"
							   tooltip="Copy Email Relay Header">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
						<div class="flex-row align-items-center gap-3">
							<span class="fw-bold" style="flex-basis: 120px; font-size: 0.9em;">Primary Key:</span>
							<input class="f-1-0 border-0 p-0" style="font-size: 12px; background: inherit;"
							       [type]="showInboundRelayKey ? 'text' : 'password'"
							       [ngStyle]="{'letter-spacing' : showInboundRelayKey ? 'normal' : '2.4px'}"
							       [ngClass]="{'nofill': !showInboundRelayKey}"
							       [(ngModel)]="wizardInfo.inbound_relay.keyAndSecret" disabled>
							<label class="hidepwd hvr-opacity" style="margin-bottom: 0; font-size: 1.2rem; cursor: pointer;"
							       [tooltip]="showInboundRelayKey ? 'Hide key' : 'Show key'">
								<input type="checkbox" [(ngModel)]="showInboundRelayKey"/>
								<i class="fas fa-eye unchecked"></i>
								<i class="fas fa-eye-slash checked"></i>
							</label>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard(wizardInfo.inbound_relay.key + ':' + wizardInfo.inbound_relay.secret);"
							   tooltip="Copy Email Relay Key">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
					</div>

					<div class="line-container">
						<hr class="custom-line">
						<div class="line-text">OR</div>
					</div>

					<div class="flex-row justify-content-between">
						<span class="fw-bold" style="font-size: 0.9rem;">SMTP Credentials Authentication</span>
					</div>
					<div class="flex-column gap-1">
						<div class="flex-row align-items-center gap-3" style="height: 30px;">
							<span class="fw-bold" style="flex-basis: 130px; font-size: 0.9em;">Host:</span>
							<span class="f-1-0">inbound-smtp.trustifi.com</span>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard('inbound-smtp.trustifi.com');"
							   tooltip="Copy Email Relay Host">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
						<div class="flex-row align-items-center gap-3" style="height: 30px;">
							<span class="fw-bold" style="flex-basis: 130px; font-size: 0.9em;">Port:</span>
							<span class="f-1-0">25<sup style="margin-left: 5px; color: green;">(StartTLS)</sup></span>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard('25');"
							   tooltip="Copy Email Relay Port">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
						<div class="flex-row align-items-center gap-3">
							<span class="fw-bold" style="flex-basis: 130px; font-size: 0.9em;">Username:</span>
							<input class="f-1-0 border-0 p-0" style="font-size: 12px; background: inherit;"
							       [type]="showInboundRelayUsername ? 'text' : 'password'"
							       [ngStyle]="{'letter-spacing' : showInboundRelayUsername ? 'normal' : '2.4px'}"
							       [ngClass]="{'nofill': !showInboundRelayUsername}"
							       [(ngModel)]="wizardInfo.inbound_relay.key" disabled>
							<label class="hidepwd hvr-opacity" style="margin-bottom: 0; font-size: 1.2rem; cursor: pointer;"
							       [tooltip]="showInboundRelayUsername ? 'Hide username' : 'Show username'">
								<input type="checkbox" [(ngModel)]="showInboundRelayUsername"/>
								<i class="fas fa-eye unchecked"></i>
								<i class="fas fa-eye-slash checked"></i>
							</label>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard(wizardInfo.inbound_relay.key);"
							   tooltip="Copy Email Relay Username">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
						<div class="flex-row align-items-center gap-3">
							<span class="fw-bold" style="flex-basis: 130px; font-size: 0.9em;">Primary Password:</span>
							<input class="f-1-0 border-0 p-0" style="font-size: 12px; background: inherit;"
							       [type]="showInboundRelayPassword ? 'text' : 'password'"
							       [ngStyle]="{'letter-spacing' : showInboundRelayPassword ? 'normal' : '2.4px'}"
							       [ngClass]="{'nofill': !showInboundRelayPassword}"
							       [(ngModel)]="wizardInfo.inbound_relay.secret" disabled>
							<label class="hidepwd hvr-opacity" style="margin-bottom: 0; font-size: 1.2rem; cursor: pointer;"
							       [tooltip]="showInboundRelayPassword ? 'Hide password' : 'Show password'">
								<input type="checkbox" [(ngModel)]="showInboundRelayPassword"/>
								<i class="fas fa-eye unchecked"></i>
								<i class="fas fa-eye-slash checked"></i>
							</label>
							<a style="font-size: 1rem;"
							   (click)="gs.copyToClipboard(wizardInfo.inbound_relay.secret);"
							   tooltip="Copy Email Relay Password">
								<i class="far fa-copy copy-link" style="cursor: pointer;"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
		</ng-container>

		<!-- CC: taken from inbound-email-relay-integration.component.html -> IP Address Set -->
		<div class="p-3 flex-column gap-4 rounded border"
			 *ngIf="(confirmedInboundArch === dic.CONSTANTS.inboundSendingArchitecture.connector || confirmedInboundArch === dic.CONSTANTS.inboundSendingArchitecture.mx) && wizardInfo?.inbound_relay?.static_ip_set_ips?.length">
			<div class="flex-column gap-2">
				<b>IP Address Set (Region: {{wizardInfo.inbound_relay.static_ip_region || 'US default'}} | Skip Certificate Validation: {{!!wizardInfo.inbound_relay.static_ip_skip_unauthorized}})</b>
				<span class="lh-base" style="font-size: 0.9em;">IP addresses that will be used to deliver emails back to your MTA.</span>
				<span class="lh-base" style="font-size: 0.9em;"><span style="color: darkorange;">NOTE:</span> For the assurance of email delivery, it is <b>recommended</b> to add these IPs to your Firewall/SEG appliances.</span>
			</div>
			<div class="flex-column gap-2">
				<span *ngFor="let ip of wizardInfo.inbound_relay.static_ip_set_ips">
					- {{ip}} <a style="font-size: 0.9rem;" (click)="gs.copyToClipboard(ip);" tooltip="Copy IP">
						<i class="copy-link far fa-copy" style="cursor: pointer;"></i>
					</a>
				</span>
			</div>
			<!--CC: Google Workspace Admin Console needs these IPs in a different format per screen-->
			<div class="flex-column gap-2" *ngIf="inboundGoogleIps && steps.environmentScope.selectedEmailService === dic.CONSTANTS.onboardingFormValues.currentEnv.gSuite">
				<b style="font-size: 0.9em;">Copy for Google Workspace Admin Console</b>
				<div class="flex-row align-items-center gap-2">
					<span style="font-size: 0.9em;">Email allowlist (comma-separated IPs)</span>
					<a style="font-size: 0.9rem;" (click)="gs.copyToClipboard(inboundGoogleIps.allowlist, 'IPs');" tooltip="Copy comma-separated IPs">
						<i class="copy-link far fa-copy" style="cursor: pointer;"></i>
					</a>
				</div>
				<div class="flex-row align-items-center gap-2">
					<span style="font-size: 0.9em;">Inbound gateway (one IP per line)</span>
					<a style="font-size: 0.9rem;" (click)="gs.copyToClipboard(inboundGoogleIps.gateway, 'IPs');" tooltip="Copy IPs, one per line">
						<i class="copy-link far fa-copy" style="cursor: pointer;"></i>
					</a>
				</div>
				<div class="flex-row align-items-center gap-2">
					<span style="font-size: 0.9em;">Content compliance rule (Received header regex)</span>
					<a style="font-size: 0.9rem;" (click)="gs.copyToClipboard(inboundGoogleIps.regex, 'Regex');" tooltip="Copy regex">
						<i class="copy-link far fa-copy" style="cursor: pointer;"></i>
					</a>
				</div>
				<code class="p-2 rounded border" style="font-size: 0.85em; word-break: break-all; background: #f8f9fa;">{{inboundGoogleIps.regex}}</code>
			</div>
		</div>

		</ng-container>
	</div>

	<!--CC: inbound verify step — polls email trace for recent inbound emails-->
	<div class="flex-column gap-3 align-items-center" *ngIf="activeStepKey === 'deployInboundShield' && activeSubStepKey === 'verify'">

		<!--CC: non-Graph architectures — trace polling-->
		<ng-container>
			<div class="flex-column gap-1 align-items-center text-center" style="max-width: 600px;">
				<span class="fw-bold" style="font-size: 1.1rem;"><i class="far fa-envelope text-primary me-2"></i>Send a test email</span>
				<span class="text-muted lh-base" style="font-size: 0.9rem;">Send an inbound email to your mail system to verify that it is being scanned by Trustifi. The trace will update automatically once the email is detected.</span>
			</div>

			<div class="flex-column gap-2 align-items-center" *ngIf="verifyTraceInProcess && !verifyTraceResults?.length">
				<search-email-loader style="transform: scale(0.7);" class="animated fadeIn"></search-email-loader>
				<span class="text-muted loading-dots" style="font-size: 0.85rem;">Waiting for emails</span>
			</div>

			<div class="flex-column gap-3 w-100 animated fadeIn" *ngIf="verifyTraceResults?.length">
			<div class="flex-row gap-3 align-items-center p-3 rounded" style="background: rgba(25, 135, 84, 0.08);" *ngIf="!verifyTraceInProcess">
				<i class="far fa-shield-check text-success" style="font-size: 1.5rem;"></i>
				<div class="flex-column gap-1">
					<span class="fw-bold text-success">Email architecture configured successfully</span>
					<span class="text-muted" style="font-size: 0.85rem;">Emails are flowing through Trustifi and being processed correctly.</span>
				</div>
			</div>
			<div class="flex-row align-items-center gap-2" *ngIf="verifyTraceInProcess">
				<loader-c class="animated fadeIn" style="width: 15px; height: 15px;"></loader-c>
				<span class="text-muted" style="font-size: 0.85rem;">Email detected, waiting for processing to complete...</span>
			</div>
			<div class="border rounded p-2">
				<table class="w-100 simpleDataTable" cellpadding="5">
					<thead>
						<tr>
							<th>Sender</th>
							<th>Recipient</th>
							<th>Subject</th>
							<th>Date</th>
							<th style="text-align: center;">Status</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let traceItem of verifyTraceResults">
							<td>{{traceItem.from}}</td>
							<td>{{traceItem.rcptTo}}</td>
							<td>{{traceItem.subject || 'None'}}</td>
							<td>{{traceItem.created | date: 'MM/dd/yyyy HH:mm'}}</td>
							<td style="text-align: center;">
								<i [ngClass]="traceItem.status === 'Completed' ? 'far fa-check-circle' : traceItem.status === 'Quarantined' ? 'far fa-bug' : traceItem.status === 'Failed' ? 'far fa-times-circle' : 'far fa-clock'"
								   [tooltip]="traceItem.status"
								   [ngStyle]="{'color' : traceItem.status === 'Completed' ? 'darkgreen' : traceItem.status === 'Quarantined' || traceItem.status === 'Failed' ? 'red' : 'grey'}"></i>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<!--CC: taken from email-trace.component.html -> trace logs display-->
			<div class="flex-column gap-1 border rounded p-3" style="background: #fafafa; font-size: 0.85rem;"
				 *ngIf="verifyTraceResults[0]?.text?.length">
				<div class="flex-row gap-1" *ngFor="let message of verifyTraceResults[0].text">
					<span class="fw-bold flex-shrink-0" *ngIf="message.timestamp">{{message.timestamp | date:'MM/dd/yyyy HH:mm:ss'}}:</span>
					<span *ngIf="message.log">{{message.log}}</span>
				</div>
			</div>
		</div>
		</ng-container>
	</div>

</ng-template>

